<template>
  <Modal
    v-model="_value"
    width="400"
    title="指派安装员"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Form ref="loginForm" :model="installOrder">
      <FormItem prop="name" label="安装员">
        <Select class="field" v-model="installOrder.installerId">
          <Option v-for="item in installers" :value="item.id" :key="item.realName===null?item.name==null?item.nickName:item.name:item.realName">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="name" label="协助人员">
        <Select class="field" multiple v-model="installOrder.installerlsit">
          <Option v-for="item in installers" :value="item.realName===null?item.name==null?item.nickName:item.name:item.realName" :key="item.realName===null?item.name==null?item.nickName:item.name:item.realName">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
        </Select>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'changeinstallermodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      installers: [],
      installOrder: {
        id: null,
        installerId: null,
        installerlsit: []
      }
    }
  },
  methods: {
    ...mapActions([
      'InstallOrderServ_ChangeInstaller',
      'UserServ_GetAllUsers',
      'InstallOrderServ_GetDetail'
    ]),
    onOk () {
      console.log(this.installOrder)
      if (this.installOrder.installerlsit.length == 0) {
        this.installOrder.installerlsit = null
      }
      this.$Modal.confirm({
        title: '指派安装员',
        content: '<p>是否确认指派安装员</p>',
        onOk: () => {
          store.dispatch('InstallOrderServ_ChangeInstaller', { params: this.installOrder }).then(() => {
            this.$Message.success('指派安装员成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.installOrder.id = null
        this.installOrder.installerId = null
        // this.installOrder.installerlsit = []

        let installOrderId = this._initValue
        if (installOrderId) {
          store.dispatch('InstallOrderServ_GetDetail', {
            params: { id: installOrderId }
          }).then(() => {
            this.installOrder = store.getters.get_InstallOrder_GetDetailResult
            this.installOrder.installerlsit = []
          }).catch(err => {
            this.$Message.error(err)
          })
        }

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8, 14] }
        }).then(() => {
          this.installers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
